import {
  GETVIEWCONGIGURATIONLIST_SUCCESS,
  GETVIEWCONGIGURATIONLIST_FAILED,
  RESET_GETVIEWCONGIGURATIONLIST,
  LOADING_GETVIEWCONGIGURATIONLIST,
  NETWORK_ERROR_GETVIEWCONGIGURATIONLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetViewConfigurationList = () => {
  return { type: RESET_GETVIEWCONGIGURATIONLIST };
};

const getViewCongigurationListReq =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETVIEWCONGIGURATIONLIST });
    await partnerServices
      .post("getViewCongigurationList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(getViewCongigurationListsuccess(res.data));
            break;
          default:
            dispatch(getViewCongigurationListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETVIEWCONGIGURATIONLIST,
          payload: err,
        });
      });
  };
function getViewCongigurationListsuccess(data) {
  return {
    type: GETVIEWCONGIGURATIONLIST_SUCCESS,
    payload: data,
  };
}
function getViewCongigurationListFailed(data) {
  return {
    type: GETVIEWCONGIGURATIONLIST_FAILED,
    payload: data,
  };
}

export { resetGetViewConfigurationList, getViewCongigurationListReq };
